import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly oauthService: OAuthService = inject(OAuthService);
  private readonly router: Router = inject(Router);

  public checkState(): void {
    if (
      this.oauthService.state &&
      this.oauthService.state !== 'undefined' &&
      this.oauthService.state !== 'null'
    ) {
      let stateUrl: string | undefined = this.oauthService.state;
      if (!stateUrl.startsWith('/')) {
        stateUrl = decodeURIComponent(stateUrl);
      }
      this.router.navigateByUrl(stateUrl);
    }
  }

  public login(kcIdpHint?: string): void {
    if (kcIdpHint) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      this.oauthService.customQueryParams = { kc_idp_hint: kcIdpHint };
    }
    this.oauthService.initLoginFlow();
  }

  public forcedLogin(): void {
    this.oauthService.initLoginFlow();
  }

  public stateLogin(targetUrl?: string): void {
    this.oauthService.initLoginFlow(targetUrl || this.router.url);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public logout(): Promise<any> {
    return this.oauthService.revokeTokenAndLogout();
  }

  public logoutWithoutRevoke(): void {
    return this.oauthService.logOut();
  }

  public userProfile(): Promise<object> {
    return this.oauthService.loadUserProfile();
  }

  public configure(config: AuthConfig): void {
    this.oauthService.configure(config);
  }
}
